export const windowFn = {
  hardRefresh: () => {
    window.location.href = window.location.href.split('?')[0] + '?refresh=' + new Date().getTime();
  }
}
